import { GLOBAL_AIRPORT_TRANSFER_SEARCH_INITIAL_STATE } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalAirportTransferSearch'
import { getTransferSearchQueryString } from 'hooks/Transfers/useTransferSearchParams'
import useQueryParams from 'hooks/useQueryParams'
import { getAirportTransferSearchStateFromParams } from 'lib/airportTransfer/airportTransferUtils'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export default function useCarsTransferSearchURLState() {
  const { pathname } = useLocation()
  const queryParams = useQueryParams()
  const transferQueryString = matchLocaleAwarePath(pathname, {
    path: '/:regionCode/cars',
    exact: true,
  })
    ? getTransferSearchQueryString(queryParams)
    : ''
  const transferQueryParams = useMemo(
    () => transferQueryString ? new URLSearchParams(transferQueryString) : undefined,
    [transferQueryString],
  )
  const initialState = useMemo(() => {
    if (!transferQueryParams) return GLOBAL_AIRPORT_TRANSFER_SEARCH_INITIAL_STATE

    const prefilledState = getAirportTransferSearchStateFromParams(transferQueryParams)

    return {
      ...GLOBAL_AIRPORT_TRANSFER_SEARCH_INITIAL_STATE,
      ...prefilledState,
      airportTransferJourneyType: prefilledState.airportTransferJourneyType ??
        GLOBAL_AIRPORT_TRANSFER_SEARCH_INITIAL_STATE.airportTransferJourneyType,
    }
  }, [transferQueryParams])

  return { initialState, transferQueryParams }
}
